import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { CustomerGroup, CustomerGroupCreate, CustomerGroupFilter } from '../data/customerGroup';

export function createCustomerGroupService(client: AxiosInstance) {
  return createCrudService<CustomerGroup, CustomerGroupCreate, CustomerGroupFilter>(
    client,
    '/crm/CustomerGroup',
    'id',
  );
}

export type CustomerGroupService = CrudService<CustomerGroup, CustomerGroupCreate, CustomerGroupFilter>;
